import { createApp } from "vue";
import App from "./App.vue";

import { store } from "./store";

import elecYesterday from "./components/elecYesterday.vue";

const appClimateWidgets = document.querySelectorAll(".appClimateWidget");

appClimateWidgets.forEach((widget) => {
  const componentToLoad = widget.dataset.component;
  const linkStorytelling = widget.dataset.lnkst;
  const modeStorytelling = widget.dataset.mode;
  if (linkStorytelling != undefined) {
    store.linkStorytelling = linkStorytelling;
  }
  if (modeStorytelling != undefined) {
    store.modeStorytelling = modeStorytelling;
  }
  // sample for single module output / show full widget if no componentToLoad defined
  if (componentToLoad == "elecYesterday") {
    const app = createApp(elecYesterday);
    app.mount("#" + widget.id);
  } else {
    const app = createApp(App);
    app.mount("#" + widget.id);
  }
});
